export default "__VITE_ASSET__BGbncMc6__"